<template>
  <div class="auth-box-w">
    <Logo/>

    <h4
        :style="{
        paddingBottom: '10px',
        borderBottom: `2px solid ${tenantColor}`,
        color: '#475569',
        fontWeight: 600,
        textAlign: 'center',
        marginBottom: '20px'
      }">
      Passwort zurücksetzen
    </h4>

    <form @submit.prevent="generateNewPassword" novalidate>
      <div class="form-group">
        <BaseInput
            v-model="formData.email"
            type="email"
            label="E-mail"
            :required=true
            :inputStyle="{ border: '1px solid rgba(0, 0, 0, 0.3)' }"
            :validation="v$.email"
            :messages="v$.email.required.$invalid ? v$.email.required.$message : v$.email.email.$message">
        </BaseInput>
        <div class="pre-icon os-icon os-icon-user-male-circle"
             :style="{ color: tenantColor }">
        </div>
      </div>

      <div class="buttons-w d-flex justify-content-between">
        <router-link
            :to="{ name: 'login' }"
            class="btn"
            :style="{ backgroundColor: tenantColor, color: 'white' }">
          Zurück
        </router-link>
        <button
            class="btn"
            type="submit"
            :style="{ backgroundColor: tenantColor, color: 'white' }">
          Senden
        </button>
      </div>
    </form>
  </div>
</template>
<script setup>
import authService from '@/api/Auth';
import BaseInput from '@/components/base/BaseInput.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
import {emailRule} from '@/shared/validators/validationRules';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import Logo from "@/components/Logo.vue";
import {useTenantColor} from "@/shared/utils/ThemeUtils";

const tenantKey = process.env.VUE_APP_TENANT_KEY
const { tenantColor } = useTenantColor(tenantKey)

const {t} = useI18n();
const isSubmitting = ref(false);
const formData = ref({
  email: '',
});

const rules = computed(() => {
  return {
    email: emailRule(t),
  };
});

const v$ = useVuelidate(rules, formData);

async function generateNewPassword() {
  try {
    v$.value.$touch();
    if (v$.value.$invalid) {
      return;
    }

    if (isSubmitting.value) return;
    isSubmitting.value = true;

    await authService.forgotPassword({email: formData.value.email});

    isSubmitting.value = false;
    await router.push({name: 'login'});

    SuccessToast('Falls ein Konto mit der E-Mail-Adresse ' + formData.value.email + ' existiert, haben wir Ihnen einen Link zum Zurücksetzen des Passworts gesendet.');
  } catch (err) {
    isSubmitting.value = false;
    await ErrorToast(err);
  }
}

onMounted(async () => {
  CloseToast();
});

</script>